// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4.15 1.9C5.18 1.9 5.85 2.62 5.85 3.65V4.25C5.85 4.75 5.64 5.12 5.21 5.41L4.85 5.66C4.59 5.84 4.5 6.15 4.66 6.46C5.74 8.65 7.35 10.26 9.54 11.34C9.85 11.5 10.16 11.41 10.34 11.15L10.59 10.79C10.88 10.36 11.25 10.15 11.75 10.15H12.35C13.38 10.15 14.1 10.82 14.1 11.85V12.4C14.1 13.5 13.44 14.14 12.4 14.1C6.72 13.86 2.14 9.28 1.9 3.6C1.86 2.56 2.5 1.9 3.6 1.9H4.15Z',
];
